import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import styles from "./CheckIcon.module.css";

const CheckIcon: React.FC = () => {
    return (
        <div className={styles.container}>
            <CheckCircleOutlineIcon fontSize="inherit" />
        </div>
    );
};

export default CheckIcon;
